import React, { Component } from 'react';
import Select from "react-select";

// Formulario de la configuracion general del reporte de matrices.
// Estilos: sistema rk- (ver .claude/docs/general/UI_CONVENTIONS.md).
// Lee la respuesta con tolerancia: si el servidor devuelve HTML (500, timeout,
// sesion vencida) se reporta el status en vez de reventar con SyntaxError.
async function readJson(res) {
    const text = await res.text();
    try {
        return JSON.parse(text);
    } catch (e) {
        return { __httpError: true, status: res.status, success:
            res.status === 500 ? "Error del servidor (500). Si acabas de desplegar, revisa que las migraciones se hayan ejecutado."
                               : `El servidor respondió ${res.status}`, type: "error" };
    }
}

class FormCreate extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;

        const r = props.register;
        this.state = {
            name: r ? r.name || "" : "",
            title: r ? r.title || "" : "",
            subtitle: r ? r.subtitle || "" : "",
            conventions_text: r ? r.conventions_text || "" : "",
            footer_text: r ? r.footer_text || "" : "",
            orientation: r ? r.orientation || "Landscape" : "Landscape",
            empty_text: r ? r.empty_text || "" : "",
            no_answer_text: r ? (r.no_answer_text === null ? "-" : r.no_answer_text) : "-",

            row_source: r ? (r.row_source || "matrices") : "matrices",
            child_format_id: r ? r.child_format_id : "",
            date_question_id: r ? r.date_question_id : "",

            dateQuestions: [],
            saving: false,
            showError: false,
        };
    }

    componentDidMount = () => {
        if (this.state.child_format_id) this.loadChildData(this.state.child_format_id);
    }

    loadChildData = (childFormatId) => {
        fetch(`/formatos/get_matrix_report_child_matrices/${childFormatId}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => {
            this.setState({
                dateQuestions: (data.date_questions || []).map(q => ({ label: q.question, value: q.id }))
            });
        });
    }

    handleChildChange = (option) => {
        this.setState({
            child_format_id: option ? option.value : "",
            date_question_id: "",
            dateQuestions: [],
        });
        if (option) this.loadChildData(option.value);
    }

    handleText = (e) => this.setState({ [e.target.name]: e.target.value });

    optionFor = (options, value) => options.find(o => String(o.value) === String(value)) || null;

    canSave = () => this.state.name.trim() !== "" && this.state.child_format_id !== "";

    handleSave = () => {
        if (this.state.saving) return;
        if (!this.canSave()) {
            this.setState({ showError: true });
            return;
        }
        this.setState({ saving: true, showError: false, serverError: null });

        const body = {
            format_id: this.props.format.id,
            child_format_id: this.state.child_format_id,
            date_question_id: this.state.date_question_id || null,
            row_source: this.state.row_source,
            name: this.state.name,
            title: this.state.title,
            subtitle: this.state.subtitle,
            conventions_text: this.state.conventions_text,
            footer_text: this.state.footer_text,
            orientation: this.state.orientation,
            empty_text: this.state.empty_text,
            no_answer_text: this.state.no_answer_text,
        };

        const url = this.props.modeEdit
            ? `/formatos/format_matrix_reports/${this.props.register.id}`
            : '/formatos/format_matrix_reports';

        fetch(url, {
            method: this.props.modeEdit ? 'PATCH' : 'POST',
            body: JSON.stringify(body),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.setState({ saving: false });
            if (!data || !data.register) {
                // el backend respondio error (o HTML de un 500): mostrarlo, no callarlo
                this.setState({ showError: true, serverError: (data && data.success) || "No se pudo guardar la configuración" });
                return;
            }
            if (this.props.modeEdit) this.props.onUpdated(data.register);
            else this.props.onCreated(data.register);
        });
    }

    render() {
        const childOptions = this.props.formatos || [];
        const { showError } = this.state;

        return (
            <div className="rk-panel mb-3" style={{ padding: '16px' }}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">Nombre de la configuración</label>
                            <input
                                type="text"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleText}
                                className={`rk-input ${showError && this.state.name.trim() === "" ? "rk-input--error" : ""}`}
                                placeholder="Ej. Preoperacional Mensual"
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">Formato de los registros diarios</label>
                            <Select
                                onChange={this.handleChildChange}
                                options={childOptions}
                                value={this.optionFor(childOptions, this.state.child_format_id)}
                                placeholder="Seleccione el formato hijo"
                                classNamePrefix="select"
                                className={showError && this.state.child_format_id === "" ? "rk-input--error" : ""}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">
                                Fecha del registro diario <small className="validate-label">(columna)</small>
                            </label>
                            <Select
                                onChange={(o) => this.setState({ date_question_id: o ? o.value : "" })}
                                options={this.state.dateQuestions}
                                value={this.optionFor(this.state.dateQuestions, this.state.date_question_id)}
                                placeholder="Pregunta fecha del hijo"
                                classNamePrefix="select"
                                isClearable
                            />
                            <small className="validate-label">
                                Define en qué columna (día) cae cada registro. El mes se elige al generar el reporte.
                            </small>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="rk-field">
                            <label className="rk-label">Origen de las filas</label>
                            <select
                                name="row_source"
                                className="rk-input"
                                value={this.state.row_source}
                                onChange={this.handleText}
                            >
                                <option value="matrices">Matrices — los ítems de cada matriz del formato diario</option>
                                <option value="steps">Secciones — las preguntas de selección, agrupadas por sección</option>
                            </select>
                            <small className="validate-label">
                                {this.state.row_source === "steps"
                                    ? "Al guardar quedan seleccionadas todas las secciones que tengan preguntas de selección; luego puedes descartar las que no quieras."
                                    : "Cada matriz es una categoría del reporte y sus ítems son las filas."}
                            </small>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">Orientación</label>
                            <select
                                name="orientation"
                                className="rk-input"
                                value={this.state.orientation}
                                onChange={this.handleText}
                            >
                                <option value="Landscape">Horizontal</option>
                                <option value="Portrait">Vertical</option>
                            </select>
                        </div>
                    </div>

                    <hr className="rk-divider" />

                    <div className="col-md-12">
                        <div className="rk-field">
                            <label className="rk-label">Título del PDF</label>
                            <input
                                type="text"
                                name="title"
                                value={this.state.title}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="REPORTE MENSUAL REVISIÓN PREOPERACIONAL"
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="rk-field">
                            <label className="rk-label">Subtítulo</label>
                            <input
                                type="text"
                                name="subtitle"
                                value={this.state.subtitle}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="EMPRESA S.A.S | NIT: 000000000-0"
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="rk-field">
                            <label className="rk-label">Convenciones</label>
                            <input
                                type="text"
                                name="conventions_text"
                                value={this.state.conventions_text}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="Convenciones: (B) Bueno (R) Regular (M) Malo..."
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="rk-field">
                            <label className="rk-label">Pie de página</label>
                            <input
                                type="text"
                                name="footer_text"
                                value={this.state.footer_text}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="Dirección, teléfono, email"
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">
                                Día sin registro <small className="validate-label">(opcional)</small>
                            </label>
                            <input
                                type="text"
                                name="empty_text"
                                value={this.state.empty_text}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="(vacío)"
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="rk-field">
                            <label className="rk-label">
                                Sin respuesta <small className="validate-label">(opcional)</small>
                            </label>
                            <input
                                type="text"
                                name="no_answer_text"
                                value={this.state.no_answer_text}
                                onChange={this.handleText}
                                className="rk-input"
                                placeholder="-"
                            />
                        </div>
                    </div>

                    {showError && (
                        <div className="col-md-12">
                            <div className="rk-alert">
                                <i className="fas fa-exclamation-circle"></i>
                                {this.state.serverError || "Debes completar el nombre y el formato de los registros diarios"}
                            </div>
                        </div>
                    )}
                </div>

                <div className="rk-modal__footer" style={{ paddingRight: 0, paddingBottom: 0 }}>
                    <button type="button" className="rk-btn rk-btn--ghost" onClick={this.props.onClose}>
                        Cancelar
                    </button>
                    <button type="button" className="rk-btn rk-btn--primary"
                        onClick={this.handleSave} disabled={this.state.saving}>
                        {this.state.saving
                            ? <><i className="fas fa-spinner fa-spin"></i> Guardando…</>
                            : <><i className="fas fa-check"></i> {this.props.modeEdit ? "Actualizar" : "Crear"}</>}
                    </button>
                </div>
            </div>
        );
    }
}

export default FormCreate;
